/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react";
import { Route } from "react-router-dom";

import ForgotPassword from "../components/login/ForgotPassword";
import MagicValidate from "../components/login/MagicValidate";
import MainRedirect from "../components/login/MainRedirect";
import ResetPassword from "../components/login/ResetPassword";
import PasswordResetSuccess from "../components/login/PasswordResetSuccess";
import { SentryRoutes } from "../Sentry/sentry";
import UnifiedLogin from "../components/login/UnifiedLogin";

class AuthRoutes extends Component {
  render() {
    return (
      <SentryRoutes>
        <Route exact path="/" element={<MainRedirect />} />
        <Route path="/login/magic/validate" element={<MagicValidate />} />
        <Route path="/login/magic" element={<UnifiedLogin />} />
        <Route path="/login/password/reset" element={<ResetPassword />} />
        <Route path="/login/password" element={<UnifiedLogin />} />
        <Route path="/login" element={<UnifiedLogin />} />
        <Route path="/login/forgot" element={<ForgotPassword />} />
        <Route
          path="/login/password-reset-success"
          element={<PasswordResetSuccess />}
        />
      </SentryRoutes>
    );
  }
}

export default AuthRoutes;
